import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AutoPairGlobalConfiguration,
  AutoPairTransitProgramConfiguration,
  OperationalFootprintConfiguration,
  OperationalFootprintInfo,
  TransitProgramInfo
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class AutoPairingService extends UzurvRestService {
  readonly resourceUrl = 'configurations/autoPair/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Get global autopairing configuration
   * @permission auto_pairing_configuration
   *
   */
  getGlobalConfiguration(): Observable<AutoPairGlobalConfiguration> {
    return this.get<AutoPairGlobalConfiguration>(`${this.resourceUrl}globals/`).pipe(
      map(response => {
        return response;
      })
    );
  }

  saveGlobalConfiguration(configuration: AutoPairGlobalConfiguration): Observable<AutoPairGlobalConfiguration> {
    return this.put<AutoPairGlobalConfiguration>(`${this.resourceUrl}globals/`, Serialize(configuration, AutoPairGlobalConfiguration)).pipe(
      map(response => {
        return Deserialize(response, AutoPairGlobalConfiguration);
      })
    );
  }
  getOperationalFootprints(pageNumber, pageSize): Observable<Array<OperationalFootprintInfo>> {
    return this.get<Array<OperationalFootprintInfo>>(`operationalFootprints/withActiveTransitProgram`, {
      pageNumber: pageNumber,
      pageSize: pageSize
    }).pipe(map(response => Deserialize(response, OperationalFootprintInfo)));
  }

  getOperationalFootprintConfiguration(operationalFootprintId: number): Observable<OperationalFootprintConfiguration> {
    return this.get<OperationalFootprintConfiguration>(`${this.resourceUrl}operationalFootprints/${operationalFootprintId}`).pipe(
      map(response => {
        return Deserialize(response, OperationalFootprintConfiguration);
      })
    );
  }
  /**
   * Get autopairing transit program configuration
   * @permission auto_pairing_configuration
   *
   * @param transitProgramId
   */
  getTransitProgramConfiguration(transitProgramId: number): Observable<AutoPairTransitProgramConfiguration> {
    return this.get<AutoPairTransitProgramConfiguration>(`${this.resourceUrl}transitPrograms/${transitProgramId}`).pipe(
      map(response => {
        return Deserialize(response, AutoPairTransitProgramConfiguration);
      })
    );
  }

  saveOperationalFootprintConfiguration(
    operationalFootprintId: number,
    configuration: OperationalFootprintConfiguration
  ): Observable<OperationalFootprintConfiguration> {
    return this.put<OperationalFootprintConfiguration>(
      `${this.resourceUrl}operationalFootprints/${operationalFootprintId}`,
      Serialize(configuration, OperationalFootprintConfiguration)
    ).pipe(
      map(response => {
        return Deserialize(response, OperationalFootprintConfiguration);
      })
    );
  }
  /**
   * Save autopairing transit program configuration
   * @permission auto_pairing_configuration
   *
   * @param transitProgramId
   * @param configuration
   */
  saveTransitProgramConfiguration(
    transitProgramId: number,
    configuration: AutoPairTransitProgramConfiguration
  ): Observable<AutoPairTransitProgramConfiguration> {
    return this.put<AutoPairTransitProgramConfiguration>(
      `${this.resourceUrl}transitPrograms/${transitProgramId}`,
      Serialize(configuration, AutoPairTransitProgramConfiguration)
    ).pipe(
      map(response => {
        return Deserialize(response, AutoPairTransitProgramConfiguration);
      })
    );
  }
}
